import { getControlPanelSource } from "@/helpers";
import $http from "@/helpers/http";
import Logger from "@/helpers/logger";

class AuthApi {
  async authenticateExternalToken(domainName, externalToken) {
    try {
      return $http.post("panel/authenticate", {
        domainName,
        externalToken,
      });
    } catch (e) {
      Logger.error("`authenticateExternalToken` api", e);
      return Promise.reject(e);
    }
  }

  login(email, password, customerId) {
    try {
      const payload = {
        email,
        password,
        source: getControlPanelSource(),
      };
      if (customerId) payload.userId = customerId;

      return $http.post("panel/login", payload);
    } catch (e) {
      Logger.error("`login` api", e);
      return Promise.reject(e);
    }
  }

  logout() {
    try {
      return $http.post("panel/logout");
    } catch (e) {
      Logger.error("`logout` api", e);
      return Promise.reject(e);
    }
  }

  forgotPassword(payload) {
    try {
      return $http.post("panel/forgot-password", payload);
    } catch (e) {
      Logger.error("`forgotPassword` api", e);
      return Promise.reject(e);
    }
  }

  resetPassword(payload) {
    try {
      return $http.post("panel/reset-password", payload);
    } catch (e) {
      Logger.error("`resetPassword` api", e);
      return Promise.reject(e);
    }
  }

  getTokenDetails(token) {
    try {
      return $http.get(`/panel/token-details?token=${token}`);
    } catch (e) {
      Logger.error("`getTokenDetails` api", e);
      return Promise.reject(e);
    }
  }

  loginWithJWT(jwt, partnerId, installId) {
    try {
      const payload = { jwt };
      if (installId) {
        payload.serverId = installId;
      } else {
        payload.partnerId = partnerId;
      }

      return $http.post("panel/authenticate/jwt", payload);
    } catch (e) {
      Logger.error("`loginWithJWT` api", e);
      return Promise.reject(e);
    }
  }

  loginWithWebmailToken(email, webmailToken) {
    try {
      const payload = { email, webmailToken };
      return $http.post("panel/authenticate/webmail", payload);
    } catch (e) {
      Logger.error("`loginWithWebmailToken` api", e);
      return Promise.reject(e);
    }
  }

  loginWithToken(token, bundleId) {
    try {
      const headers = {
        Authorization: token,
        "X-Auth": "controlPanel",
      };

      return $http.get(
        `internal/domain/validate-admin-panel-token${bundleId ? `?bundleId=${bundleId}` : ""}`,
        {
          headers,
        }
      );
    } catch (e) {
      Logger.error("`loginWithToken` api", e);
      return Promise.reject(e);
    }
  }
}

const authApi = new AuthApi();

export default authApi;
